import { AppErrorBoundary } from "@/app/AppErrorBoundary";
import { AppController } from "@/app/AppController";
import { prepareForAppReload } from "@/app/reload-guard";
import { useServiceWorkerUpdate } from "@/pwa/register-service-worker";

function AppContent() {
  const serviceWorker = useServiceWorkerUpdate();

  return (
    <>
      <AppController />
      {serviceWorker.needRefresh ? (
        <div className="pwa-toast" role="status">
          An update is ready.
          <button
            type="button"
            onClick={() => {
              void (async () => {
                const saved = await prepareForAppReload();
                if (
                  saved ||
                  window.confirm(
                    "The open note could not be saved. Apply the update and reload anyway?",
                  )
                ) {
                  await serviceWorker.applyUpdate();
                }
              })();
            }}
          >
            Apply
          </button>
          <button type="button" onClick={serviceWorker.dismissRefresh}>
            Later
          </button>
        </div>
      ) : null}
    </>
  );
}

export function App() {
  return (
    <AppErrorBoundary>
      <AppContent />
    </AppErrorBoundary>
  );
}
